// ============================================
// アビリティ状態管理
// ============================================

import type { BombExplosion, BarrageMissile } from '../types/game-types';

// --- ボムストック ---
let _bombStock: number = 3;

// --- ホーミング ---
let _homingStock: number = 3;
let _homingActive: boolean = false;
let _homingTimer: number = 0;

// --- 荷電粒子砲 ---
let _cannonStock: number = 3;
let _cannonCharging: boolean = false;
let _cannonActive: boolean = false;
let _cannonTimer: number = 0;
let _cannonDamageTimer: number = 0;

// --- ボムエフェクト用変数 ---
let _bombExplosions: BombExplosion[] = [];
let _bombEffectTimer: number = 0;
let _isBombActive: boolean = false;
let _bombDamageTimer: number = 0;
let _bombTickTimer: number = 0;

// --- ミサイル弾幕用変数 ---
let _barrageMissiles: BarrageMissile[] = [];

// ============================================
// Getters and Setters
// ============================================

// --- ボム ---
export const getBombStock = (): number => _bombStock;
export const setBombStock = (val: number): void => {
    _bombStock = val;
};

// --- ホーミング ---
export const getHomingStock = (): number => _homingStock;
export const setHomingStock = (val: number): void => {
    _homingStock = val;
};

export const getHomingActive = (): boolean => _homingActive;
export const setHomingActive = (val: boolean): void => {
    _homingActive = val;
};

export const getHomingTimer = (): number => _homingTimer;
export const setHomingTimer = (val: number): void => {
    _homingTimer = val;
};

// --- 荷電粒子砲 ---
export const getCannonStock = (): number => _cannonStock;
export const setCannonStock = (val: number): void => {
    _cannonStock = val;
};

export const getCannonCharging = (): boolean => _cannonCharging;
export const setCannonCharging = (val: boolean): void => {
    _cannonCharging = val;
};

export const getCannonActive = (): boolean => _cannonActive;
export const setCannonActive = (val: boolean): void => {
    _cannonActive = val;
};

export const getCannonTimer = (): number => _cannonTimer;
export const setCannonTimer = (val: number): void => {
    _cannonTimer = val;
};

export const getCannonDamageTimer = (): number => _cannonDamageTimer;
export const setCannonDamageTimer = (val: number): void => {
    _cannonDamageTimer = val;
};

// --- ボムエフェクト ---
export const getBombExplosions = (): BombExplosion[] => _bombExplosions;
export const setBombExplosions = (val: BombExplosion[]): void => {
    _bombExplosions = val;
};

export const getBombEffectTimer = (): number => _bombEffectTimer;
export const setBombEffectTimer = (val: number): void => {
    _bombEffectTimer = val;
};

export const getIsBombActive = (): boolean => _isBombActive;
export const setIsBombActive = (val: boolean): void => {
    _isBombActive = val;
};

export const getBombDamageTimer = (): number => _bombDamageTimer;
export const setBombDamageTimer = (val: number): void => {
    _bombDamageTimer = val;
};

export const getBombTickTimer = (): number => _bombTickTimer;
export const setBombTickTimer = (val: number): void => {
    _bombTickTimer = val;
};

// --- ミサイル弾幕 ---
export const getBarrageMissiles = (): BarrageMissile[] => _barrageMissiles;
export const setBarrageMissiles = (val: BarrageMissile[]): void => {
    _barrageMissiles = val;
};
